<template>
  <section>
    <b-modal width="680px" :active.sync="active">

      <!-- 単一アイテムのモーダル (editModalTarget.dataが単一オブジェクト) -->
      <div class="card" style="border-radius: 5px;" v-if="editModalTarget.data.length==undefined">
        <header class="card-header">
          <p class="card-header-title title">
            メディア詳細 / 変更
          </p>
        </header>
        <div class="card-content" v-if="active">
          <img   class="modal-media" v-if="editModalTarget.type=='image'" :src="editModalTarget.data.image_data">
          <video class="modal-media" v-if="editModalTarget.type=='video'" :src="editModalTarget.data.video_data" controls></video>
          <div style="display: flex;">
            <input  class="input is-small"  style="border-right: none; border-radius: 0;" v-model="name">
            <button class="button is-small is-primary" style="border-radius: 0;" @click="updateImage()">名前の変更</button>
          </div>
          <div style="width: 100%; height: 150px; overflow-y: scroll;">
            <h2 style="width: 100%; text-align: left; margin: 8px; font-weight: 600;"><span class="mdi mdi-folder" style="margin-right: 4px;"></span>使用箇所</h2>
            <p style="padding-left: 16px; width: 100%; text-align: left; font-size: smaller;" v-for="(mes, idx) in this.editModalTarget.referrers" :key=idx>・{{ mes }}</p>
          </div>
          <button style="margin-top: 8px; margin-bottom: 8px;" class="button is-small is-primary is-fullwidth" @click="$store.dispatch('mediapool/closeEditModal')">戻る</button>
          <div style="width: 100%; text-align: end;">
            <button v-if="!archiveFlag" class="button is-small" style="background: #f4a460;" @click="archiveImage(true)"><span class="mdi mdi-archive" style="margin-right: 4px;"></span>アーカイブ</button>
            <button v-else class="button is-small" style="background: #f4a460;" @click="archiveImage(false)"><span class="mdi mdi-undo" style="margin-right: 4px;"></span>元に戻す</button>
            <button class="button is-danger is-small"  name="modal-delete-button" @click="OpenDeleteModal(null)"><span class="mdi mdi-delete" style="margin-right: 4px;"></span>削除する</button>
          </div>
        </div>
      </div>

      <!-- 複数アイテムのモーダル (editModalTarget.dataがリスト) -->
      <div class="card" style="border-radius: 5px;" v-if="editModalTarget.data.length!=undefined">
        <header class="card-header">
          <p class="card-header-title title">
            メディア一括変更
          </p>
        </header>
        <div class="card-content" v-if="active">
          <div class="tag is-primary is-small" style="margin-right: 100%; height: 27px; float: left;">
            <input class="edit-taginput" placeholder="タグを設定" v-model="multiTag"/>
            <button class="plus-button mdi mdi-plus mdi-24px" @click="multiTagUpdate()"></button>
          </div>
          <div style="height: 60px;">
            <button class="tag is-small buttonCandidate"  v-for="(t, i) in tagList" :key="i"  @click="multiTagUpdate(t[0])">
              {{t[0]}}
            </button>
          </div>
          <div style="width: 100%; text-align: end;">
            <button class="button is-danger is-small" @click="OpenDeleteModal(null)"><span class="mdi mdi-delete" style="margin-right: 4px;"></span>削除する</button>
          </div>
          <div class="media-wrapper" v-for="(item, idx) in editModalTarget.data" :key="idx">
            <img   class="modal-multi-media" v-if="editModalTarget.type=='image'" :src="item.image_data">
            <video class="modal-multi-media" v-if="editModalTarget.type=='video'" :src="item.video_data" muted></video>
          </div>
        </div>
      </div>

      <!-- 削除時のモーダル -->
      <b-modal width="500px" :active.sync="deleteModalFlg" :on-cancel="deletePageCancel">
        <div class="card" style="border-radius: 5px;">
          <header class="card-header">
            <p class="card-header-title title" style="font-size: 20px;">
              {{mediaType()}}の削除
            </p>
          </header>
          <div class="card-content">
            <p style="margin-bottom: 16px;">選択中{{mediaType()}}:<span style="margin-left: 8px; font-weight: bold;">{{getSubString(editModalTarget.data.name, 20)}}</span></p>
            <h2 style="font-size: 16px; margin-bottom: 16px; color: red;">一度削除した{{mediaType()}}は元に戻すことができません。<br>本当に選択した{{mediaType()}}を削除してもよろしいですか？</h2>
            <div style="display: flex; justify-content: space-around; align-items: center; flex-wrap: wrap;">
              <button style="width: 140px;" class="button" @click="deletePageCancel('cancel')">キャンセル</button>
              <button style="width: 140px;" class="button is-danger" name="delete-confirmation-button" @click="deleteImage()">削除する</button>
            </div>
          </div>
        </div>
      </b-modal>

    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import controlLogMixin from '@/mixins/controlLogMixin'

export default {
  name: 'ModalEditMedia',
  components:{
  },
  mixins: [
    controlLogMixin
  ],
  data () {
    return {
      active: false,
      name: '',
      deleteModalFlg: false,
      selectDeletePage: {},
      multiTag: '',
      tagList:[
        ["採用", "さいよう", "saiyou"],
        ["求人", "きゅうじん", "kyuujinn"],
        ["求人ノベル", "きゅうじんのべる", "kyuujinnnoberu"],
        ["求人ページ", "きゅうじんぺーじ", "kyuujinnpe-ji"],
        ["人物", "じんぶつ", "jinnbutsu"],
        ["背景", "はいけい", "haikei"],
        ["ロボ", "ろぼ", "robo"]
      ],
    }
  },
  computed: {
    ...mapState('mediapool', ['images', 'videos', 'editModalActive', 'editModalTarget', 'archiveFlag']),
  },
  mounted () {
    console.debug('*** Start *** mounted')
    console.debug('*** End *** mounted')
  },
  watch: {
    editModalActive () {
      this.active = this.editModalActive
      this.name = this.editModalTarget.data.name
    },
    active () {
      if (this.active == false) {
        this.$store.dispatch('mediapool/closeEditModal')
      }
      else if (this.editModalTarget.data.length==undefined) {
        if (this.editModalTarget.type=='image') this.$store.dispatch('mediapool/getImageReferrers', {id: this.editModalTarget.data.image_id})
        else if (this.editModalTarget.type=='video') this.$store.dispatch('mediapool/getVideoReferrers', {id: this.editModalTarget.data.video_id})
      }
    }
  },
  methods: {
    updateImage() {
      this.sendControlLog('メディア倉庫　名称変更', '')
      let updateData = this.editModalTarget.data
      updateData.name = this.name
      if (this.editModalTarget.type=='image') this.$store.dispatch('mediapool/updateImage', updateData)
      else if (this.editModalTarget.type=='video') this.$store.dispatch('mediapool/updateVideo', updateData)
    },
    deleteImage(){
      this.sendControlLog('メディア倉庫　削除', '')
      this.$store.dispatch('mediapool/closeEditModal')
      if (this.editModalTarget.data.length === undefined) {
        // 単一選択
        if (this.editModalTarget.type=='image') {
          this.$store.dispatch('mediapool/deleteImage', this.editModalTarget.data.image_id)
          .then(() => {
            this.deleteModalFlg = false
          })
        }
        else if (this.editModalTarget.type=='video') {
          this.$store.dispatch('mediapool/deleteVideo', this.editModalTarget.data.video_id)
          .then(() => {
            this.deleteModalFlg = false
          })
        }
      } else {
        //複数選択
        let count = this.editModalTarget.data.length
        for (let item of this.editModalTarget.data) {
          if (this.editModalTarget.type=='image') {
            this.$store.dispatch('mediapool/deleteImage', item.image_id)
            .then(() => {
              count--
              if (count == 0) this.deleteModalFlg = false
            })
          }
          else {
            this.$store.dispatch('mediapool/deleteVideo', item.video_id)
            .then(() => {
              count--
              if (count == 0) this.deleteModalFlg = false
            })
          }
        }
      }
    },
    archiveImage(flg){
      let updateData = this.editModalTarget.data
      updateData.is_archive = flg
      this.$store.dispatch('mediapool/closeEditModal')
      if (this.editModalTarget.type=='image') this.$store.dispatch('mediapool/updateImage', updateData)
      else if (this.editModalTarget.type=='video') this.$store.dispatch('mediapool/updateVideo', updateData)
      var message = ""
      if(flg) message = "アーカイブしました。"
      else message = "元に戻しました。"
      this.$buefy.snackbar.open({
          message: message,
          type: 'is-success',
          position: 'is-top',
          actionText: 'OK',
          indefinite: true
        })
    },
    multiTagUpdate(tag) {
      console.debug('*** Start *** updateTags')
      if (tag === undefined) {
        tag = this.multiTag
        this.multiTag = ''
      }
      if (tag == '') {
        alert('文字を入力してください。')
        return
      }
      for (let item of this.editModalTarget.data) {
        var tagBox = []
        if (item.tags) {
          tagBox.push(item.tags.split(","))
          if (tagBox[0].indexOf(tag) == -1){
            let updateItem = item
            if (updateItem.tags) updateItem.tags += tag + ','
            else updateItem.tags = tag + ','
            if (this.editModalTarget.type == 'image') this.$store.dispatch('mediapool/updateImage', updateItem)
            else this.$store.dispatch('mediapool/updateVideo', updateItem)
          }
        }
        else {
          let updateItem = item
          updateItem.tags = tag + ','
          if (this.editModalTarget.type == 'image') this.$store.dispatch('mediapool/updateImage', updateItem)
          else this.$store.dispatch('mediapool/updateVideo', updateItem)
        }
      }
      console.debug('*** End *** updateTags')
    },
    getSubString (m, num) {
      if (this.editModalTarget.data.length == undefined) {
        if (m) {
          return m.length < num ? m : m.substring(0, num - 3) + '...'
        } else {
          return 'no title'
        }
      } else {
        m = this.editModalTarget.data[0].name
        return (m.length < num ? m : m.substring(0, num-3) + '...') + ' など' + this.editModalTarget.data.length + '個'
      }
    },
    OpenDeleteModal (c) {
      this.selectDeletePage = c
      this.deleteModalFlg = true
    },
    closeDeleteModal () {
      this.deleteModalFlg = false
    },
    deletePageCancel (c) {
      if (c === 'cancel') {
        this.deleteModalFlg = false
      }
      this.selectDeletePage = {}
    },
    mediaType () {
      if (this.editModalTarget.type == 'image') {
        return '画像'
      } else if (this.editModalTarget.type == 'video') {
        return '動画'
      }
    }
  }
}
</script>

<style lang='scss' scoped>

.modal-media {
  height: 300px;
  width: 100%;
  object-fit: scale-down;
}

.media-wrapper {
  position:relative;
  overflow: hidden;
  width: 25%;
  display: inline-block;
}

.media-wrapper::before {
  content: "";
  display: block;
  padding-top: 100%;
}

.modal-multi-media {
  object-fit: scale-down;
  position: absolute;
  top: 0;
  left: 3%;
  bottom: 0;
  right: 0;
  width: 94%;
  height: 94%;
}

.title {
  font-size: 22px;
  font-weight: 700;
  padding: 20px;
  border-bottom: solid thin #ccc;
}

.card-header-title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.edit-taginput {
  background: rgba(255,255,255, 0.00) !important;
  width: 80px;
  text-align: center;
  color: white;
  border: none;
  font-size: 12px;
  option {
    color: #000;
  }
}
.edit-taginput::placeholder {
  color: white;
  font-size: 12px;
}

.plus-button {
  background: rgba(255, 255, 255, 0.0);
  cursor: pointer;
  color: white;
  border: none;
  outline : none;
}

.buttonCandidate{
  background-color: white;
  float:left;
  margin-right: 5px;
  margin-bottom: 5px;
  border:solid black 1px;
  cursor: pointer;
  cursor: hand;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/ModalEditMedia.vue